/* eslint-disable no-nested-ternary */
import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { useSendCommunicationModal } from '../context/SendCommunicationModalContext';

import RecipientChip from './RecipientChip';
import CategoryChip from './CategoryChip';

const RecipientsList: FC = () => {
  const { t } = useTranslate();
  const { data } = useSendCommunicationModal();

  return (
    <div>
      <div className="recipients-list">
        {data.selectedPartnerCategoryOption ? (
          <CategoryChip
            key={data.recipients?.[0]?.id}
            recipient={data.recipients[0]}
          />
        ) : data.recipients.length > 0 ? (
          <div className="d-flex flex-wrap">
            {data.recipients.map((r) => (
              <RecipientChip key={r.id} recipient={r} />
            ))}
          </div>
        ) : (
          <p className="text-muted mb-0">{t('NoRecipientsAdded')}</p>
        )}
      </div>
    </div>
  );
};

export default RecipientsList;
